/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Coffees = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.06977 3.5L4.85548 4.5H13.1445L12.9302 3.5H5.06977ZM3.68776 2.79047L3.32143 4.5H3C2.44772 4.5 2 4.94772 2 5.5V7.5C2 8.05228 2.44772 8.5 3 8.5H3.1L4 22H14L14.9 8.5H15C15.5523 8.5 16 8.05228 16 7.5V5.5C16 4.94772 15.5523 4.5 15 4.5H14.6786L14.3122 2.79047C14.2134 2.3294 13.806 2 13.3344 2H4.66556C4.19402 2 3.78656 2.3294 3.68776 2.79047ZM4.50333 7H3.5V6H4.23699H13.763H14.5V7H13.4967H4.50333ZM5.17 17L4.60333 8.5H13.3967L12.83 17L5.17 17ZM5.27 18.5L5.40333 20.5H12.5967L12.73 18.5H5.27ZM19.763 6H17.5V5.5C17.5 4.94772 17.0523 4.5 16.5 4.5H19.1445L18.9302 3.5H15.9643L15.8122 2.79047C15.7134 2.3294 15.3059 2 14.8344 2H19.3344C19.806 2 20.2134 2.3294 20.3122 2.79047L20.6785 4.5H21C21.5523 4.5 22 4.94772 22 5.5V7.5C22 8.05228 21.5523 8.5 21 8.5H20.9L20 22H15.5L15.6 20.5H18.5966L18.73 18.5H15.7333L15.8333 17H18.83L19.3966 8.5H16.5C17.0523 8.5 17.5 8.05228 17.5 7.5V7H19.4966H20.5V6H19.763Z"
                        fill={color}
                    />
                </svg>
        );
    };
